/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { Dropdown } from "semantic-ui-react";
import allAxiosCommonRequest from '../axiosComponent/allAxiosCommonRequest';

const YardDropdown = ({
  field: { name },
  form: { setFieldValue },
  getYardSelected,
  ...props
}) => {
  const [yard, setYard] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    allAxiosCommonRequest({ url: 'masters/yard', method: 'get' })
      .then((response) => {
        setYard(response.data.resultSet);
      })
      .catch((error) => console.log(error));
    setIsLoading(false);
  }, []);

  let options = [];
  if (yard && yard.length > 0) {
    yard.map((object, index) => {
      let temp = {}
      temp.key = object.yardCode
      temp.text = `${object.yardCode} - ${object.yardName}`
      temp.value = object.yardId
      return options[index] = temp
    })
  }

  const handleChange = (e, data) => {
    setFieldValue(name, data.value);
    if (props?.placeholderName) {
      let selected = data.options.filter((object, index) => {
        if (object.value == data.value) {
          return object.text
        }
      });
      setFieldValue(props.placeholderName, selected[0]?.text);
    }
  };

  return (
    <Dropdown
      selection
      search
      onChange={handleChange}
      placeholder={props.placeholder}
      options={options}
      loading={isLoading}
      {...props}
      fluid
    />
  );
};

export default YardDropdown;
